module.exports = __webpack_public_path__ + "img/SchoolAdmin.a7d8f967.png";